"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleFiles = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var common_1 = require("../../../common");
var hooks_1 = require("../../../common/hooks");
var download_svg_1 = __importDefault(require("../../../assets/images/download.svg"));
var App_1 = require("../../../components/App");
var styles = __importStar(require("./ArticleFiles.module.css"));
var ArticleFiles = function (_a) {
    var files = _a.files;
    var widgetSettings = (0, react_1.useContext)(App_1.WidgetContext).widgetSettings;
    var formatFileSize = (0, hooks_1.useFileSizeFormatter)();
    var linkDomain = widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.host;
    if (!linkDomain)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.files }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: styles.filesTitle }, { children: files.length > 0 && (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: 'files' }) })), files.map(function (file, index) { return ((0, jsx_runtime_1.jsxs)("a", __assign({ href: "https://".concat(linkDomain).concat(file.link), target: '_blank', rel: 'noreferrer', className: styles.fileLinkWrapper }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.file }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: styles.fileName }, { children: (0, common_1.truncateMiddle)(file.original_name, 20) })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: styles.fileSize }, { children: ["(", formatFileSize(file.file_size), ")"] }))] })), (0, jsx_runtime_1.jsx)("img", { src: download_svg_1.default, alt: 'download icon', draggable: 'false' })] }), index)); })] })));
};
exports.ArticleFiles = ArticleFiles;
